import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'
import FrontAuthorizationShopInfo from '../entities/front-authorizationshop'
import appconst from '@/lib/appconst';


interface AuthorizationShopInfoState extends ListState<FrontAuthorizationShopInfo> {
    AuthorizationShopInfo: FrontAuthorizationShopInfo,
}

class FrontAuthorizationShopInfoMutations extends ListMutations<FrontAuthorizationShopInfo>{

}
class AuthorizationShop extends ListModule<AuthorizationShopInfoState, any, FrontAuthorizationShopInfo>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<FrontAuthorizationShopInfo>(),
        loading: false,
        AuthorizationShopInfo: FrontAuthorizationShopInfo,
        shopid:0

    }
    actions = {
        async getAll(context: ActionContext<AuthorizationShopInfoState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/AuthorizationShop/GetAuthorizationShopList', { params: payload.data });
            context.state.loading = false;
            let page = reponse.data.result as PageResult<FrontAuthorizationShopInfo>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        async addauthorizationshop(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/AuthorizationShop/ProcessAuthorizer', payload.data);
            return rep.data.result;
        },
        async deleteAuthorizationShopList(state: any, payload: any) {
            await Ajax.post('/api/services/app/AuthorizationShop/DeleteAuthorizationShopList', payload.data);
        },
        async getUrl(state: any, payload: any) {
            let rep = await Ajax.get('/api/services/app/AuthorizationShop/GetComeBackUrl', payload.data);
            return rep.data.result;
        },
        async getCancelUrl(state: any, payload: any) {
            let rep = await Ajax.get('/api/services/app/AuthorizationShop/GetCancelComeBackUrl', payload.data);
            return rep.data.result;
        },
        async SynchronizationOrder(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/ShopeeOrder/BatchCreate', payload.data);
            return rep.data.result;
        },
        async cancelauthorization(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/AuthorizationShop/CancelAuthorizationShop', payload.data);
        },
        async DwonLoadPdf(state: any, payload: any) {
            let rep = await Ajax.get('/api/services/app/ShopeeOrder/DwonLoadPdf?orderNumber=' + payload.data.orderNumber);
            return rep.data.result;
        },
        async customShopName(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/AuthorizationShop/CustomShopName?shopId=' + payload.data.shopId + '&customShopName=' + payload.data.customShopName);
        },
    };
    mutations = {
        setCurrentPage(state: AuthorizationShopInfoState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: AuthorizationShopInfoState, pagesize: number) {
            state.pageSize = pagesize;
        },
        getImgUrl(state: AuthorizationShopInfoState, data: any) {
           
         data.url = appconst.remoteServiceBaseUrl + "/api/services/app/AuthorizationShop/GetComeBackUrl";
      
        }

    }
}

const authorizationShop = new AuthorizationShop();
export default authorizationShop;